import { apiService } from '../APIService';

export default {
  createKeyWord(params) {
    return apiService.post('tags', params);
  },
  getKeyWords(params) {
    return apiService.get('tags', params);
  },
  deleteKeyWord(id) {
    return apiService.delete(`tags/${id}`);
  },

  createSynonym(params) {
    return apiService.post('tag-synonyms', params);
  },
  getSynonym(params) {
    return apiService.get('tag-synonyms', params);
  },
  deleteSynonym(id) {
    return apiService.delete(`tag-synonyms/${id}`);
  },

  createHint(params) {
    return apiService.post('hints', params);
  },
  updateHint(params) {
    const { id } = params;
    return apiService.put(`hints/${id}`, params);
  },
  getHints(params) {
    return apiService.get('hints', params);
  },
  deleteHint(id) {
    return apiService.delete(`hints/${id}`);
  },

  bindKeyWord(id, params) {
    return apiService.post(`/hints/${id}/attach-tags`, params);
  },
  updateBindKeyWord(id, params) {
    return apiService.put(`/hints/${id}/attach-tags`, params);
  },
  unBindKeyWord(id, params) {
    return apiService.post(`/hints/${id}/detach-tags`, params);
  },
  bindProject(id, params) {
    return apiService.post(`/hints/${id}/attach-projects`, params);
  },
  unBindProject(id, params) {
    return apiService.post(`/hints/${id}/detach-projects`, params);
  },
};
